import {EventEmitter} from "./EventEmitter";

export type BaseConfiguration = {}

export class Base
{
    protected eventEmitter: EventEmitter;
    protected configuration: BaseConfiguration = {};

    constructor(...configurations: object[])
    {
        const defaults: BaseConfiguration = {};

        this.mergeConfiguration(defaults, ...configurations);
        this.eventEmitter = new EventEmitter();
    }

    public on(eventName: string, fn: Function): this
    {
        this.eventEmitter.on(eventName, fn);

        return this;
    }

    public once(eventName: string, fn: Function): this
    {
        this.eventEmitter.once(eventName, fn);

        return this;
    }

    public off(eventName: string, fn: Function): this
    {
        this.eventEmitter.off(eventName, fn);

        return this;
    }

    public trigger(eventName: string, detail: object = {}): this
    {
        let defaultDetail: object =
            {
                target: this,
            };

        this.eventEmitter.trigger(eventName, Object.assign(defaultDetail, detail));

        return this;
    }

    public listenerCount(eventName: string): number
    {
        return this.eventEmitter.listenerCount(eventName);
    }

    public rawListeners(eventName: string)
    {
        return this.eventEmitter.rawListeners(eventName);
    }

    protected mergeConfiguration(...configurations: object[]): this
    {
        this.configuration = this.mergeDeep({}, this.configuration, ...configurations);

        return this;
    }

    protected mergeDeep(...objects: object[]): object
    {
        const isObject = obj => obj && typeof obj === "object" && !(obj instanceof Base);

        return objects.reduce((prev: object, obj: object) =>
        {
            Object.keys(obj).forEach(key =>
            {
                const pVal: any = prev[key];
                const oVal: any = obj[key];

                if (Array.isArray(pVal) && Array.isArray(oVal))
                {
                    // prev[key] = pVal.concat(...oVal);
                    prev[key] = [...pVal, ...oVal].filter((element, index, array) => array.indexOf(element) === index);
                }
                else if (isObject(pVal) && isObject(oVal))
                {
                    prev[key] = this.mergeDeep(pVal, oVal);
                }
                else
                {
                    prev[key] = oVal;
                }
            });

            return prev;
        }, {});
    }
}
